/* ============================================================
   VEGECORE — First-order discount popup, updated 2026-08-24
   NOW EMAIL-GATED: the TRYVEGECORE code is revealed only after the
   visitor submits their email, which subscribes them to email
   marketing through Shopify's native customer form. That consent is
   what lets the abandoned-cart recovery Flow actually email them.
   Markup lives in snippets/vc-exit-popup.liquid (needs Liquid for
   the {% form 'customer' %} tag), so this file only handles showing,
   hiding and the copy button — it no longer builds the markup.
   Trigger: ~2.5s universal timer on mobile + desktop, with
   exit-intent as an earlier bonus trigger on desktop.
   Skipped on cart/checkout templates. Only loaded for guests /
   customers with 0 prior orders (guarded in layout/theme.liquid).
   ============================================================ */
(function () {
  var CODE = 'TRYVEGECORE';
  var STORAGE_KEY = 'vcExitPopupSeen';
  var SHOW_DELAY_MS = 2500;  // universal fast-trigger delay
  var MIN_TIME_MS = 800;     // guard so exit-intent can't fire on page-load jitter

  function init() {
    var overlay = document.getElementById('vcExitPop');
    if (!overlay) return;

    // Did the visitor just submit the form? Shopify bounces back with
    // ?customer_posted=true and the snippet renders the success state.
    var justPosted =
      !!overlay.querySelector('[data-vc-posted]') ||
      window.location.search.indexOf('customer_posted=true') !== -1;

    var shown = false;
    var startTime = Date.now();
    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    function close() {
      overlay.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { overlay.setAttribute('hidden', ''); }, 250);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    function open() {
      if (shown) return;
      shown = true;
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}

      overlay.removeAttribute('hidden');
      // force a reflow so the opacity transition actually runs
      void overlay.offsetWidth;
      overlay.classList.add('is-open');

      document.addEventListener('keydown', onKey);
      var email = overlay.querySelector('input[type="email"]');
      if (email) { try { email.focus({ preventScroll: true }); } catch (e) {} }
    }

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    var closeBtn = overlay.querySelector('.vc-exitpop-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    var copyBtn = overlay.querySelector('[data-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        function fallbackCopy() {
          var ta = document.createElement('textarea');
          ta.value = CODE;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(CODE).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
        var original = copyBtn.textContent;
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = original; }, 1800);
      });
    }

    // Just subscribed: always show the code straight away, even if this
    // browser has seen the popup before.
    if (justPosted) { open(); return; }

    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch (e) {}

    var skipClasses = ['template-cart', 'template-checkout'];
    var bodyClass = document.body.className || '';
    for (var i = 0; i < skipClasses.length; i++) {
      if (bodyClass.indexOf(skipClasses[i]) !== -1) return;
    }

    setTimeout(open, SHOW_DELAY_MS);

    if (!isTouch) {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 0 && Date.now() - startTime > MIN_TIME_MS) open();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
